import { mergeEntities, ListReducer, ObjectReducer } from '../store';
import { transformUser } from '../user/user.reducer';
import { User } from '../user/user.model';
import {
  Thread,
  ThreadUnreadCount,
  ThreadsGetApiResponse,
} from './thread.model';

export const threadReducer: ListReducer<'threads'> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload && action.payload.ref.path[0] === 'threads') {
        const ref = action.payload.ref;
        // action.payload.ref.path[1] is the user. Use it for now.
        const selfId = Number(ref.path[1]);
        const data = <ThreadsGetApiResponse>action.payload.data;

        // Denormalize the Thread API response
        const contextDetails = data.context_details;
        const users = data.users;
        const threads = data.threads.reduce(
          // FIXME: thread: any inference needs to go. ContextApi is incorrect.
          (acc: { [threadId: string]: Thread }, thread: any) => {
            const context = { ...thread.thread.context };
            if (context) {
              if (context.type === 'project') {
                context.project = contextDetails.projects[context.id];
              } else if (context.type === 'contest') {
                context.contest = contextDetails.contests[context.id];
              }
              context.id = undefined;
            }
            // FIXME: The explicit type here is because thread is still an any.
            const members: User[] = thread.thread.members.map(
              (memberId: number) => transformUser(users[memberId]),
            );
            const owner = transformUser(users[thread.thread.owner]);
            const otherMembers = members.filter(member => member.id !== selfId);

            let title = '';
            let subtitle = '';
            const membersString = thread.thread.members
              .filter((userId: number) => userId !== selfId)
              .map((userId: number) => users[userId].username)
              .join(', ');

            title = membersString;

            if (
              thread.thread.context &&
              thread.thread.context.type === 'project' &&
              contextDetails.projects[thread.thread.context.id]
            ) {
              title = contextDetails.projects[thread.thread.context.id].title;
              subtitle = membersString;
            }

            const threadInner = {
              ...thread.thread,
              context,
              members,
              owner,
              otherMembers,
              title,
              subtitle,
            };
            const messages =
              thread.messages &&
              thread.messages.map((message: any) => {
                return {
                  ...message,
                  fromUser: transformUser(users[message.from_user]),
                };
              });
            acc[thread.id] = {
              ...thread,
              thread: threadInner,
              time_read: thread.time_read * 1000,
              time_updated: thread.time_updated * 1000,
              messages,
            };
            return acc;
          },
          {},
        );

        return mergeEntities<'threads'>(state, threads, ref);
      }
      return state;

    /*case 'WEBSOCKET_LOAD_SUCCESS':
      const threadId: any = action.payload.thread_id;
      let newThreads: any = {};
      const thread: any = state[threadId];
      if (!thread) {
        return state;
      }
      const now = Date.now();
      const newTimeUpdated: any = { time_updated: now };
      newThreads[threadId] = Object.assign({}, thread, newTimeUpdated);
      return Object.assign({}, state, newThreads);*/

    default:
      return state;
  }
};

export const threadUnreadCountReducer: ObjectReducer<'threadUnreadCount'> = (
  state: {},
  action,
) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'threadUnreadCount'
      ) {
        const { data, ref } = action.payload;
        //  return mergeEntities(state, data.unread_thread_count, ref);
        return state;
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/thread/thread.reducer.ts